export default __webpack_public_path__ + "static/media/team-foto2.d53e1724.png";